const stats = [
  { value: "210+", label: "连载话数", icon: "ri-book-open-line" },
  { value: "68", label: "笑点合集", icon: "ri-video-chat-line" },
  { value: "12w+", label: "每日轻松看读者", icon: "ri-user-heart-line" },
  { value: "9.8", label: "读者评分", icon: "ri-star-fill" },
];

function Stats() {
  return (
    <section className="relative z-10 container-page -mt-10 pb-4 md:-mt-14">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {stats.map((item) => (
          <div
            key={item.label}
            className="flex flex-col items-center gap-1 rounded-2xl bg-background-50 p-5 text-center shadow-sm md:p-6"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600">
              <i className={item.icon}></i>
            </span>
            <span className="font-heading text-3xl text-foreground-950">{item.value}</span>
            <span className="text-sm text-foreground-500">{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;